<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import * as dd from 'dingtalk-jsapi'; // 此方式为整体加载，也可按需进行加载
import { getTicket } from './utils/api'
import { req } from './utils/commonFunc'
import axios  from 'axios';
export default{
  data(){
    return{
      
    }
  },
  methods:{

    ddConfigEvent(){
      var configData = JSON.parse(localStorage.getItem('configData'));
      console.log(configData,'configData222222222');
      dd.config({
                    agentId:configData.agentId, // 必填，微应用ID
                    corpId: configData.corpId,//必填，企业ID
                    timeStamp: configData.timeStamp, // 必填，生成签名的时间戳
                    nonceStr: configData.nonceStr, // 必填，自定义固定字符串。
                    signature: configData.signature, // 必填，签名
                    type:0,   //选填。0表示微应用的jsapi,1表示服务窗的jsapi；不填默认为0。该参数从dingtalk.js的0.8.3版本开始支持
                    jsApiList : [
                        'runtime.info',
                        'biz.contact.complexPicker',
                        'biz.contact.choose',
                        'device.notification.confirm',
                        'device.notification.alert',
                        'device.notification.prompt',
                        'biz.ding.post',
                        'biz.util.openLink',
                    ] // 必填，需要使用的jsapi列表，注意：不要带dd。
                  });

                  dd.error(function (err) {
                      // alert('dd error: ' + JSON.stringify(err));
                      console.log('dd error: ' + JSON.stringify(err));
                  })//该方法必须带上，用来捕获鉴权出现的异常信息，否则不方便排查出现的问题
    },
    //测试
    ddEvent(){
          dd.biz.contact.complexPicker({
          title:"选择部门和人",            //标题
          corpId:"ding2c7e12ec92b333ec35c2f4657eb6378f",              //企业的corpId
          multiple:true,            //是否多选
          limitTips:"超出了",          //超过限定人数返回提示
          maxUsers:1000,            //最大可选人数
          pickedUsers:[],            //已选用户
          pickedDepartments:[],          //已选部门
          disabledUsers:[],            //不可选用户
          disabledDepartments:[],        //不可选部门
          requiredUsers:[],            //必选用户（不可取消选中状态）
          requiredDepartments:[],        //必选部门（不可取消选中状态）
          appId:2465673439,              //微应用Id，企业内部应用查看AgentId
          permissionType:"GLOBAL",          //可添加权限校验，选人权限，目前只有GLOBAL这个参数
          responseUserOnly:false,        //返回人，或者返回人和部门
          startWithDepartmentId:0 ,   //仅支持0和-1
          onSuccess: function(result) {
            console.log(result,'result');
              /**
              {
                  selectedCount:1,                              //选择人数
                  users:[{"name":"","avatar":"","emplId ":""}]，//返回选人的列表，列表中的对象包含name（用户名），avatar（用户头像），emplId（用户工号）三个字段
                  departments:[{"id":,"name":"","number":}]//返回已选部门列表，列表中每个对象包含id（部门id）、name（部门名称）、number（部门人数）
              }
              */
          },
         onFail : function(err) {}
      });
    }
  },
  created(){
    let apiHost             = '';
    let uploadUrl           = '';
    let ak                  = '';
    let secret              = '';
    if(req().host.indexOf('cloud.ebyte.com') >= 0){
        apiHost             = 'https://cloud.ebyte.com';
        ak                  = '17be0ce1f1ddc9cecfadc0b6d6161b63';
        secret              = 'zU7tIoV.enxCjncnOU3.0xvX3DJrVsTZDdxHqtkVBjFs5hfiWgO';
    }else if(req().host.indexOf('dev.ebyte.com') >= 0){
        apiHost             = 'https://dev.ebyte.com';
        ak                  = '570aa8918a20da4dce1a84959f6237c6';
        secret              = 'cd/OYGOHAB26ESEje8.enmtWBI6KcVZygFqtFJ.7jgMIXj78LLq';
    }

    axios.defaults.baseURL  = apiHost;
    localStorage.setItem('uploadUrl', apiHost+'/open/api/v1/attach/uploader?user_token=');
    localStorage.setItem('urlHerf', apiHost);
    localStorage.setItem('ak', ak);
    localStorage.setItem('secret', secret);

    //#此处不知是做何用途，后续清除
    setTimeout(()=>{
      console.log('jqxx');
      this.ddConfigEvent()
    },6000)//what fuck is this?
  }
}

</script>


<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}

html,
body {
  height: 100%;
  overflow: auto;
  margin: 0;
  padding:0;
}
html {
  overflow-y: auto;
}
</style>
